import { useState, useEffect } from 'react'
import { getUserLocalStorage } from '../../../../context/util';
import { URLS } from '../../../../infra/URLS';
import { Botao } from "../../../../shared/components/Botao";
import { LoadingPage } from '../../../../shared/components/LoadingPage';
import { ConfirmDeleteModal } from '../../../../shared/components/Modal/ConfirmDeleteModal';
import { TableInfo } from "../../../../shared/components/Table";
import { IconAdicionar } from "../../../../shared/Icons/IconAdicionar";
import { IconDownload } from "../../../../shared/Icons/IconDownload";
import { IconTrash } from '../../../../shared/Icons/IconTrash';
import { useGetArquivos, useGetArquivoToken } from '../../hooks/useGetArquivos';
import deleteArquivo from '../../queries/deleteArquivo';
import { colunasUpload } from "../../util/ColunasUpload";
import { Upload } from './Upload';

interface ArquivoUploadProps {
  ClienteId: number
}

export function ArquivosUpload({ ClienteId } : ArquivoUploadProps) {

  const [modalUpload, setModalUpload] = useState<boolean>(false)
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [deleteFile, setDeleteFile] = useState<string>('')
  const [modalDelete, setModalDelete] = useState<boolean>(false)

  function handleDeleteFile(record : any) {
    setDeleteFile(record.nome)
    setModalDelete(!modalDelete)
  }

  async function handleDownloadFile(record: any) {
    // const urlBase = process.env.REACT_APP_BASE_URL
    const user = getUserLocalStorage()

    await fetch(`${URLS.DOWNLOAD_ARQUIVO_API}${record.url}`, {
      headers: new Headers({
        'Authorization': `Bearer ${user.accessToken}`
      }) 
    }).then((r) => window.open(r.url))

  }

 

  const {data: token} = useGetArquivoToken(ClienteId, deleteFile)

  const { data: listaArquivos, isLoading } = useGetArquivos(ClienteId)

  useEffect(() => {
    listaArquivos && setUploadedFiles(listaArquivos)
  }, [listaArquivos])

  async function onDelete() {
    navigator.onLine && token && await deleteArquivo(token.url, () => setModalDelete(!modalDelete))
  }

  const dataArquivos = uploadedFiles?.map((item: any, index:number) => ({
    ...item,
    key: index,
  }) )

  console.log(dataArquivos)
  
  const columns = [
    ...colunasUpload,
    {
      title: "Ações",
      dataIndex: "action",
      key: "action",
      width: 50,
      render: (text: any, record: any, index: any) => {
        return (
          <div className=" flex justify-center gap-3">
            <button
              type="button"
              className="bg-gray-400 hover:bg-primary-hover p-1 text-gray-100 rounded-full"
              onClick={() => handleDownloadFile(record)}
            >
              <IconDownload width="20" height="20" />
            </button>
            <button
              type="button"
              className="bg-gray-400 hover:bg-primary-hover p-1 text-gray-100 rounded-full"
              onClick={() => handleDeleteFile(record)}
            >
              <IconTrash width="20" height="20" color="#fff"/>
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="flex flex-row mb-4 justify-between items-center">
        <h1 className="font-bold">Arquivos do cliente</h1>
        <Botao
          type="button"
          className="bg-primary text-white"
          icon={<IconAdicionar color="#fff"/>}
          texto="Novo Arquivo"
          onClick={() => setModalUpload(!modalUpload)}
        />
      </div>
      
      {
        isLoading ? 
          <div className="flex justify-center items-center">
            <LoadingPage />
          </div>
        :
        <TableInfo
          dataSource={dataArquivos}
          columns={columns}
        />
      }

      {
        modalUpload && <Upload 
          ClienteId={ClienteId} 
          isOpen={modalUpload}
          setIsOpen={setModalUpload}
        />
      }

      <ConfirmDeleteModal
        isModalOpen={modalDelete}
        title="Deletar Arquivo"
        mensagem="Você tem certeza que desejar excluir este arquivo?"
        onDelete={onDelete}
        closeModal={() => setModalDelete(!modalDelete)}
      />
    </>
  );
}